export default __webpack_public_path__ + "static/media/Unread-Message-Notification.6e988011.png";